import TicketCard from "./TicketCard";

const TicketList = ({ tickets }) => {
  return (
    <div className="space-y-4">
      {tickets.map((ticket) => (
        <TicketCard key={ticket._id} ticket={ticket} />
      ))}
    </div>
  );
};

export default TicketList;
